// extracted by mini-css-extract-plugin
module.exports = {"container":"Service_container__18BAU","eli-container":"Service_eli-container__1w8Ri"};